module.exports = __webpack_public_path__ + "static/media/logo_webbanner.1f2ecda3.png";